import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function TermsOfService() {
  return (
    <Container style={{ marginTop: "30px" }}>
      <Row>
        <Col xs={1} md={4}></Col> {/* Left Empty Space */}
        <Col xs={10} md={4} className="text-center"> {/* Left Align */}
          <p style={{ fontWeight: "bold", fontSize: "3rem" }}>
            Terms of Service
          </p>
          <p style={{ fontWeight: "bold", fontSize: "1rem" }} className="text-start">Introduction:</p>
          <p style={{ fontSize: "0.9rem" }} className="text-start">
          a. This website is owned and operated by Blissful Beauty (hereinafter and throughout this website referred to as “we”, “us” and “our”). Our registered office is at House 11, Street 64, G-13/2, Islamabad. Our principal place of business is located at House 11, Street 64, G-13/2, Islamabad.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          b. We offer this website, including all information, tools, products, and services available from this website to you, the user, conditioned upon your acceptance of all terms, conditions, policies, and notices stated here.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          c. If you have any problems placing your order on our website or require support after placing an order through our website, please contact us by calling us on +923334479230 or send us an email at blissfulbeautypakistan@gmail.com.
          </p>

          <br />
         
          <p style={{ fontWeight: "bold", fontSize: "1rem" }} className="text-start">Applicability and Updates:</p>
          <p style={{ fontSize: "0.9rem" }} className="text-start">
          a. By visiting our site and/or purchasing something from us, you engage in our “Service” and agree to be bound by the following terms and conditions (“Terms and Conditions”), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms and Conditions apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/or contributors of content.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          b. In consideration of your use of our website and services, you represent that you are of legal age to form a binding contract and are not a person barred from receiving products and services under the laws of Pakistan or other applicable jurisdiction.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          c. We may need to update our Terms and Conditions from time to time; each time you place an order on our website, you will be agreeing to the latest version of our Terms and Conditions.
          </p>

          <br />
          
          <p style={{ fontWeight: "bold", fontSize: "1rem" }} className="text-start">Terms of Usage:</p>
          <p style={{ fontSize: "0.9rem" }} className="text-start">
          a. You are prohibited from using this website or its content:
          </p>

          <br />

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          for any unlawful purpose;
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          to solicit others to perform or participate in any unlawful acts;
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          to violate any international, federal, provincial, or state laws, regulations, and rules;
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          to infringe upon or violate our intellectual property rights or the intellectual property rights of others;
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability;
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          to submit false or misleading information;
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the service or interfere with or circumvent the security features of our service, any related website, other websites, or the internet;
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          to collect or track the personal information of others or spam, phish, pharm, pretext, spider, crawl, or scrape; or
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          for any obscene or immoral purpose.
          </p>


          <p style={{ fontSize: "0.9rem" }} className="text-start">
          b. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.
          </p>

          <br />


          
          <p style={{ fontWeight: "bold", fontSize: "1rem" }} className="text-start">Intellectual Property:</p>
          <p style={{ fontSize: "0.9rem" }} className="text-start">
          This website and its related software and content (including images and designs) are the intellectual property of and are exclusively owned by us. The structure, organization, and code of the website and its related software contain valuable trade secrets and confidential information of Blissful Beauty. Except as expressly stated herein, these terms and conditions do not grant you any intellectual property rights whatsoever in the website and its related software and all rights are reserved by Blissful Beauty.
          </p>

          <br />
          
          <p style={{ fontWeight: "bold", fontSize: "1rem" }} className="text-start">Indemnity and Limitation of Liability:</p>
          <p style={{ fontSize: "0.9rem" }} className="text-start">
          a. You agree to indemnify us, defend, and hold us harmless and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns, and employees, harmless from any claim or demand, including reasonable attorneys’ fees, made by any third-party due to or arising out of your breach of these Terms and Conditions or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          b. Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness, or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          c. Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services, or information available through this website meet your specific requirements.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          d. To the extent permitted by law, we also disclaim all warranties, whether express or implied, including the implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          e. We reserve the right to not process an order that you place on our website. This is usually for the following reasons:
          </p>

          <br />

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          We no longer hold stock of the goods or services that you ordered from us.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          We are unable to ship goods to your location.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          The goods or services that you have ordered are no longer available.
          </p>

          <br />
         
          <p style={{ fontWeight: "bold", fontSize: "1rem" }} className="text-start">Cancellation of Orders:</p>
          <p style={{ fontSize: "0.9rem" }} className="text-start">
          a. If you wish to cancel your order, please contact us immediately at +923334479230 or email us at blissfulbeautypakistan@gmail.com. We will do our best to accommodate your request, but please note that once an order has been processed, it may not be possible to cancel it.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          b. If the order has already been shipped, you will need to follow our returns procedure to return the products.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          c. We reserve the right to cancel any order for any reason. Some common reasons for cancellation include:
          </p>

          <br />

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          The product is not available or out of stock.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          Errors in the product price or description.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          Inability to process your payment.
          </p>

          <p style={{ fontSize: "0.9rem" }} className="text-start">
          Delivery to the provided address is not feasible.
          </p>

          <br />

          <p style={{ fontWeight: "bold", fontSize: "1rem" }} className="text-start">Termination:</p>
          <p style={{ fontSize: "0.9rem" }} className="text-start">
          We may immediately change or terminate your access to our products, services, and this website, or any online membership(s) with us, with or without notice, at any time, without liability to you, any other user, or any third party. We reserve the right to terminate your access if, without limitation, you have: (1) provided us with false or misleading registration information; (2) interfered with other users or the administration of our services or websites; (3) upon a request by law enforcement or other governmental authorities; or (4) otherwise violated these Terms and Conditions.
          </p>

          <br />

          <p style={{ fontWeight: "bold", fontSize: "1rem" }} className="text-start">Severability and Waiver:</p>
          <p style={{ fontSize: "0.9rem" }} className="text-start">
          If any portion of these terms is found to be unenforceable, the unenforceable portion will be deemed amended to the minimum extent necessary to make it enforceable, and if it can't be made enforceable, then it will be severed and the remaining portion will remain in full force and effect. If we fail to enforce any of these terms, it will not be considered a waiver. Any amendment to or waiver of these terms must be made in writing and signed by us.
          </p>

          <br />

          <p style={{ fontWeight: "bold", fontSize: "1rem" }} className="text-start">Governing Law:</p>
          <p style={{ fontSize: "0.9rem" }} className="text-start">
          Our Terms and Conditions are governed by the laws of the Islamic Republic of Pakistan, and you agree that the courts of Pakistan (including any consumer court) will have exclusive jurisdiction in any dispute that you have with us.
          </p>
          
          

          <br /> <br /> <br />

        </Col>
        <Col xs={1} md={4}></Col> {/* Right Empty Space */}

     
      </Row>
    </Container>
  );
}

export default TermsOfService;